module.exports = __webpack_public_path__ + "img/tg_ic.8f0c1e44.svg";